<template lang="pug">
  .container.grid-lg.py-2
    .no-print
      form-filter(@submit="onFilter" :auto-filter='autoFilter' :default-query='q' filter-key='doc-implantacoes-filters')

    load-manager(:status='status')
      list-manager(:status='status', :count='list.length')
        table.table.table-striped.table-sm
          thead
            tr
              th {{ "doc.numero" | tModel }}/{{ "doc.ano" | tModel }}
              th {{ "doc.tipo" | tModel }}
              th {{ "doc.cadastro" | tModel }}
              th {{ "doc.situacao" | tModel }}
              th {{ "doc.autuado_em" | tModel }}
              th {{ "doc.fiscal" | tModel }}
              th.text-right {{ "doc.valor_total" | tModel }}
              th.actions-col
          tbody
            tr(v-for="doc in list")
              td {{ doc.numero }}/{{ doc.ano }}
              td {{ doc | enums("doc.tipo") }}
              td
                small
                  span.abbr {{ doc.cadastro | enums('cadastro.tipo') }}
                span  {{ doc.cadastro.numero }}
              td {{ doc.situacao.descricao }}
              td {{ doc.autuado_em | date }}
              td {{ doc.fiscal ? doc.fiscal.nome : "-" }}
              td.text-right {{ doc.valor_total | currency("R$ ") }}
              td.actions-col
                router-link.btn.btn-action.btn-sm.btn-link.tooltip.tooltip-left(
                  data-tooltip="Implantar"
                  :to="{name: 'fiscalizacao.docImplantacoes.implantar', params: {id: doc.id}}"
                )
                  i.fa.fa-eye
                a.btn.btn-action.btn-sm.btn-link.tooltip.tooltip-left(
                  :href='doc.url'
                  target='_blank'
                  data-tooltip='Imprimir'
                )
                  btn-icon(name='print')
                a.btn.btn-action.btn-sm.btn-link.tooltip.tooltip-left(
                  data-tooltip='PDF'
                  :href='`${doc.url}.pdf`'
                  target='_blank'
                )
                  i.fa.fa-file-pdf-o
        .my-2.text-right(v-if='pages > 1')
          btn-paginate(:page='page', :pages='pages', :count='count', @go-page='goPage', @prev-page='prevPage', @next-page='nextPage')
</template>

<script>
import { vuexDefaultMapping } from '@/mixins/list'
import FormFilter from '../docs/components/Filter'

export default {
  vuex: {
    'fiscalizacao/docImplantacoes': vuexDefaultMapping,
  },

  components: { FormFilter },

  data() {
    return { q: { id_order_by: 'asc' } }
  },

  methods: {
    onFilter(q = {}) {
      this.q = { ...q }
      this.setQuery({ ...q })
      this.setPage(1)
      this.fetchList()
    },
  },

  computed: {
    autoFilter() {
      return !this.list || this.list.length === 0
    },
  },

  created() {
    this.q = { ...this.q, ...this.query }
  },
}
</script>
